import React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';

import WriteButton from './WriteButton';
import Export from './Export';
import { withAppContext } from './AppContext';

function encryptText(text) {
  text = `${text}`.replace(/['-']/g,'').replace(/['–']/g,'');
  return btoa(text);
}

function generateAIOutline(encodedDescription,generateType) {
  const type = 'book';
  window.location.href = `https://www.squibler.io/onboarding/?redirectStoryScript=true&PID=''&next=${type}&generateType=${generateType}&description=${encodedDescription}`
}


function generateAIBook(encodedDescription,generateType) {
  const type = 'book';
  window.location.href = `https://www.squibler.io/onboarding/?redirectStoryScript=true&PID=''&next=${type}&generateType=${generateType}&description=${encodedDescription}`
}

const Failure = ({ onReset, toggleHelp, limit, type, lost, words, text }) => {
  const encryptedText = encryptText(text);

  return (
    <CSSTransitionGroup
      transitionName="failure"
      transitionEnterTimeout={500}
      transitionLeaveTimeout={100}
    >
      {lost && (

        <div className="modal failure" tabIndex="-1" role="dialog" key="failScreen" >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
             
              <div className="modal-body inner">
                {/* <iframe className="typeform-share button survey" src="https://squibler.typeform.com/to/wx311q">
                  <a data-mode="popup" data-auto-open="true" target="_blank" rel="noopener noreferrer"> */}

                <h3 className="title failure-title my-3" >How do you want to continue your story?
                </h3>
               
                <div className="row justify-content-center mt-4 p-1">
                  <div className="col-md-5 col-sm-12 selecting-outline-content-card normal mb-3">
                    <div className="selecting-outline-content-card-content-text" onClick={() => generateAIBook(encryptedText,'entire_book')}>
                      <i className="fak fa-squibler-novel fa-lg"></i>
                      <span>Generate Full-Length Book with AI</span>
                      <span className="selecting-outline-content-card-content-subtext pl-4 pr-4">
                        Let AI generate a complete book based on your writing so far. You will have the opportunity to edit it later.
                      </span>
                    </div>
                  </div>
                  <div className="col-md-5 col-sm-12 selecting-outline-content-card normal mb-3">
                    <div className="selecting-outline-content-card-content-text" onClick={() => generateAIOutline(encryptedText,'entire_outline')}>
                      <i className="fak fa-smart-writer fa-lg"></i>
                      <span>Generate Personalized <br className="d-none d-md-inline"/> Outline with AI</span>
                      <span className="selecting-outline-content-card-content-subtext pl-4 pr-4">
                        Let AI generate a book outline based on your writing so far. You will have the opportunity to edit it later.
                      </span>
                    </div>
                  </div>
                </div>

                </div>
                <div className='d-flex gen-new-prompt px-5 mx-3 pb-3'>
                  Or &nbsp;<a className='' href="/plot-generator"> generate a new prompt.</a>
                </div>
              </div>
            </div>
          </div>
      )}
    </CSSTransitionGroup>
  )
}

export default withAppContext(Failure);
